module.exports = __webpack_public_path__ + "static/img/17.ba285e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/体彩竞技/17.png
// module id = mRxd
// module chunks = 1